// utils/request.js
import axios from 'axios'
import { ElLoading,ElMessage } from 'element-plus'
export const isCache = true
// export const baseUrl = ''
// export const imageUrl = "http://localhost:18031/"
// export const baseUrl = 'http://192.168.0.246:4399/api/'
// export const imageUrl = "http://127.0.0.1:8080/"
// export const baseUrl = 'http://192.168.1.81:4399/api/'
// export const imageUrl = "http://192.168.1.81/"
export const baseUrl = 'https://dip.sylvoxtv.com/api/'
export const imageUrl = 'https://dip.sylvoxtv.com/'
export const uploadUrl = baseUrl + 'uploadfile'
export const uploadExcel = baseUrl + 'uploadExcel'
// 创建axios实例
const service = axios.create({
    baseURL:baseUrl ,
    timeout: 60*1000,
    // ...其他配置
    loadingDelay: 300,
    loadingText: '加载中...'
})
// 全局Loading状态管理
let loadingInstance = null
let needLoadingRequestCount = 0

// 显示Loading
function showLoading(config) {
    if (config.loading !== false) {
        if (needLoadingRequestCount === 0) {
            loadingInstance = ElLoading.service({
                lock: true,
                text: config.loadingText || '加载中...',
                background: config.loadingBackground || 'rgba(0, 0, 0, 0.2)',
                // spinner: config.loadingSpinner || 'el-icon-loading',
                // loadingSpinner: 'el-icon-upload' // 自定义加载图标
            })
        }
        needLoadingRequestCount++
    }
}

// 隐藏Loading
function hideLoading() {
    needLoadingRequestCount = Math.max(0, needLoadingRequestCount - 1)
    if (needLoadingRequestCount === 0) {
        loadingInstance?.close()
        loadingInstance = null
    }
}

// 请求拦截器
service.interceptors.request.use(config => {
    // 延迟显示loading（防闪烁）
    config.loadingTimer = setTimeout(() => {
        showLoading(config)
    }, config.loadingDelay || 300)

    // 携带token
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    config.headers.lang =  localStorage.getItem('lang') ? localStorage.getItem('lang') : "en"
    if (config.method === 'get' && config.params) {
        config.url += '?' + Object.entries(config.params)
            .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
            .join('&');
        config.params = {}; // 清空避免重复编码
    }
    return config;
}, error => {
    clearTimeout(error.config?.loadingTimer)
    hideLoading()


    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
    response => {
        clearTimeout(response.config.loadingTimer)
        hideLoading()
        // 处理业务状态码
        if (response.data.Code !== 0 && response.data.code != 200) {
            if (response.data.Msg!==""&&response.data.Msg!==null || response.data.msg!=="") {
                ElMessage.error(response.data.Msg || response.data.msg)
            }else{
                ElMessage.error(response.data.Msg || response.data.msg)
            }
            if (response.data.Code==301) {
                let username = localStorage.getItem("username");
                localStorage.clear()
                localStorage.setItem("username", username);
                setTimeout(()=>{
                    window.location.href = "/"
                },1000)

            }
            return Promise.reject(response.data)
        }
        return response.data
    },
    error => {
        clearTimeout(error.config?.loadingTimer)
        hideLoading()
        // 统一错误处理
        let message = ''
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    message = '登录已过期，请重新登录'

                    break
                case 404:
                    message = '请求资源不存在'
                    break
                default:
                    message = error.response.data.Msg || '请求错误'
            }
        } else {
            message = '网络连接异常'
        }
        ElMessage.error(message)
        if (error.response.status==401) {
            window.location.href ="/"
        }
    }
)

// 封装通用方法
const http = {
    get(url, params, config) {
        return service.get(url, { params, ...config })
    },

    post(url, data, config) {
        return service.post(url, data, config)
    },

    put(url, data, config) {
        return service.put(url, data, config)
    },

    delete(url, config) {
        return service.delete(url, config)
    }
}

export default http
